import React, { createContext, useState, useEffect, useContext } from 'react'
import Parse from 'parse'

const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    checkUser()
  }, [])

  const checkUser = async () => {
    setLoading(true)
    try {
      const currentUser = Parse.User.current()
      if (currentUser) {
        // Verificar si la sesión del usuario es válida
        await currentUser.fetch()
        setUser(currentUser)
      } else {
        setUser(null)
      }
    } catch (error) {
      console.error("Error checking user:", error)
      setUser(null)
    } finally {
      setLoading(false)
    }
  }

  const login = async (username, password) => {
    setLoading(true)
    try {
      const loggedInUser = await Parse.User.logIn(username, password)
      setUser(loggedInUser)
      return loggedInUser
    } catch (error) {
      throw error
    } finally {
      setLoading(false)
    }
  }

  const logout = async () => {
    setLoading(true)
    try {
      await Parse.User.logOut()
      setUser(null)
    } catch (error) {
      console.error("Error logging out:", error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)